import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel'; // Import the Carousel from react-bootstrap
import firstImage from '../assets/firstImage.jpg';  // Your images
import secondImage from '../assets/secondImage.png';
import thirdImage from '../assets/thirdImage.jpg';

function ControlledCarousel() {
  const [index, setIndex] = useState(0);  // Handle current active index

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);  // Change the index when a slide is selected
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
        {/* first image */}
        <img
          className="d-block w-100"
          src={firstImage}
          alt="First slide"
        />
        <Carousel.Caption>
          <h3>EXTRA GAMING SKILLS</h3>
          <p>MOBILE LEGENDS</p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        {/* Second image */}
        <img
          className="d-block w-100"
          src={secondImage}
          alt="Second slide"
        />
        <Carousel.Caption>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        {/* Third image */}
        <img
          className="d-block w-100"
          src={thirdImage}
          alt="Third slide"
        />
        <Carousel.Caption>
          <h3>EXTRA GAMING SKILLS</h3>
          <p>CLASH OF CLANS</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default ControlledCarousel;
